/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehaviorBipInfoModel } from '../../models/behavior-bip-info-model';

export interface SaveBehaviorBIPInfo$Params {
      body?: BehaviorBipInfoModel
}

export function SaveBehaviorBIPInfo(http: HttpClient, rootUrl: string, params?: SaveBehaviorBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<BehaviorBipInfoModel>> {
  const rb = new RequestBuilder(rootUrl, SaveBehaviorBIPInfo.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BehaviorBipInfoModel>;
    })
  );
}

SaveBehaviorBIPInfo.PATH = '/api/Staff/SaveBehaviorBIPInfo';
